export default {
  //获取参数
  getUrlParam (name) {
      return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
  },
  //识别手机浏览器
  isMobileClient () {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) ){
      return false;
      } else {
      return true;
      }
  },
  //随机字符串
  uniqueId (len, is_sub = true) {
      len = len || 32;
      var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = $chars.length;
      var pwd = '';
      for (var i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }

      if (is_sub) {
          return '__'+pwd;
      }

      return pwd;
  },
  //是否数组
  isArray (obj) {
      if (!obj) return false;
      return (typeof obj=='object') && obj.constructor==Array;
  },
  //数组去重
  arrayUnique(arr) {
      return Array.from(new Set(arr))
  },
  //是否手机号
  isMobile (mobile) {
      var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})||(19[0-9]{1}))+\d{8})$/;
      if(!myreg.test(mobile)) {
      return false;
      }
      return true;
  },
  //是否邮箱
  isEmail (email) {
      var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
      return reg.test(email);
  },
  //格式化时间错
  dateFormart(sj) {
      sj= parseInt(sj);
      var now = new Date(sj*1000);
      var year=now.getFullYear();
      var month=now.getMonth()+1;
      var date=now.getDate();
      var hour=now.getHours();
      var minute=now.getMinutes();
      var second=now.getSeconds();
      return year+"-"+month+"-"+date+"   "+hour+":"+minute;
  },
//设置cookie
setCookie(name, value, seconds) {
    seconds = seconds || 0;
    var expires = "";
    if (seconds != 0) {
        var date = new Date();
        date.setTime(date.getTime() + (seconds * 1000));
        expires = "; expires=" + date.toGMTString();
    }

    // 获取当前主机名 (不带端口)
    var hostname = window.location.hostname;
    var domainStr = "";

    // 只有当 hostname 不是 IP 地址且包含点号时，才尝试提取主域名
    // 正则校验是否为 IP (简单判断)
    var isIp = /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname);

    if (!isIp && hostname !== 'localhost' && hostname.includes('.')) {
        var domainParts = hostname.split('.');
        if (domainParts.length > 2) {
            var domain = domainParts.slice(-2).join('.');
            domainStr = "; domain=" + domain;
        } else {
            domainStr = "; domain=" + hostname;
        }
    } else {
        // 如果是 IP 或 localhost，不写 domain 属性，浏览器会自动处理为当前主机
        domainStr = "";
    }

    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + domainStr;
},
  //获取cookie
  getCookie (c_name) {
      if (document.cookie.length > 0) {
          var c_start = document.cookie.indexOf(c_name + "=")
          if (c_start != -1) {
          c_start = c_start + c_name.length + 1
          var c_end = document.cookie.indexOf(";", c_start)
          if (c_end == -1) c_end = document.cookie.length
          return unescape(document.cookie.substring(c_start, c_end)).replace(/\"/g, "");
          }
      }
      return null;
  },
  
  //今天
  getTodayDate () {
      var day2 = new Date();
      day2.setTime(day2.getTime());

      var year = day2.getFullYear();
      var month = (day2.getMonth()+1);
      var day = day2.getDate();

      month = parseInt(month) < 10 ? '0'+month : month;
      day = parseInt(day) < 10 ? '0'+day : day;

      return year + '-' + month + '-' + day;
  },
  //上个月的今天
  getLastMonthToday () {
      var now=new Date();
      var year = now.getFullYear();//getYear()+1900=getFullYear()
      var month = now.getMonth() +1;//0-11表示1-12月
      var day = now.getDate();
      if(parseInt(month)<10){
          month="0"+month;
      }
      if(parseInt(day)<10){
          day="0"+day;
      }
  
      now =year + '-'+ month + '-' + day;
  
      if (parseInt(month) ==1) {//如果是1月份，则取上一年的12月份
          return (parseInt(year) - 1) + '-12-' + day;
      }
  
      var  preSize= new Date(year, parseInt(month)-1, 0).getDate();//上月总天数
      if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
          return year + '-' + month + '-01';
      }
  
      if(parseInt(month) <=10){
          return year + '-0' + (parseInt(month)-1) + '-' + day;
      }else{
          return year + '-' + (parseInt(month)-1) + '-' + day;
      }
  },
  //数组是否有值
  in_array (val, arr) {
      for (var i=0; i<arr.length; i++) {
          if (arr[i] == val) {
              return true;
          }
      }

      return false;
  },
  //生成随机字符串
  shuffle (len) {
      len = len || 32;
      var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = $chars.length;
      var pwd = '';
      for (var i = 0; i < len; i++) {
          pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
  },       
  //保留两位小数
  floatMoney (num) {
      var result = parseFloat(num);
      if (isNaN(result)) {
          return 0.00;
      }
      result = Math.round(num * 100) / 100;
      var s_x = result.toString();
      var pos_decimal = s_x.indexOf('.');
      if (pos_decimal < 0) {
          pos_decimal = s_x.length;
          s_x += '.';
      }
      while (s_x.length <= pos_decimal + 2) {
          s_x += '0';
      }
      return s_x;
  },
  //整型转字符串
  to_string(num){
      num = num.toString()
      return num
  },  
  //递归获取对象数组内某个字段集合, condition为条件组合
  getFieldInTree(obj, filedName, condition = false, array = []) {
      if (!obj) obj = [];
      for (var i=0; i<obj.length; i++) {
        if(condition===false || (condition[1]==obj[i][condition[0]]) ) {
          array.push(obj[i][filedName]);
        } 
        if (obj[i].hasOwnProperty('children') && obj[i].children.length) {
          this.getFieldInTree(obj[i].children, filedName, condition, array);
        }
      }
      return array;
  },
  //递归获取树下的一个节点
  getTreeFieldItem(obj, filedName, condition = false, array = []) {
      if (!obj) obj = [];
      for (var i=0; i<obj.length; i++) {
        if(condition===false || (condition[1]==obj[i][condition[0]]) ) {
          array.push(obj[i]);
        } 
        if (obj[i].hasOwnProperty('children') && obj[i].children.length) {
          this.getTreeFieldItem(obj[i].children, filedName, condition, array);
        }
      }
      return array;    
  },
  //挂载子节点
  insertTreeNode (data, node) {
      for (let i = 0; i < data.length; i++) {
          if (data[i].id === node.pid) {
              if (!data[i].children) {
                  data[i].children = [];
              }
              data[i].children.push(node);
              return data;
          }
          if (data[i].children && this.insertTreeNode(data[i].children, node)) {
              return data;
          }
      }
      return data;
  },
  //清空一个对象的值
  clearObj:function (obj) {
      for (var i in obj) {
          if ( (typeof obj[i]=='object') ) {
          if ( obj[i] && obj[i].constructor==Array ) {
              obj[i] = [];
          } else {
              this.clearObj(obj[i]);
          }
          } else if (isNaN(obj[i])) {
          obj[i] = '';
          } else {
          obj[i] = '';
          }
      }

      return obj;
  },
  filterArr(arr){
      var tmp = [];
      arr.map((item) =>{
          if (item) {
              tmp.push(item)
          }
      })

      return tmp
  },
  //复制一个对象的值，避免引用传递 污染数据源
  copyObj:function (obj) {
      var newObj = {};  
      if (obj instanceof Array) {  
          newObj = [];  
      }  
      for (var key in obj) {  
          var val = obj[key];  
          //newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; //arguments.callee 在哪一个函数中运行，它就代表哪个函数, 一般用在匿名函数中。  
          newObj[key] = typeof val === 'object' ? this.copyObj(val): val;  
      }  
      return newObj;  
  },
  //调试
  myprint:function (msg, deli = 'debug') {
      console.log(deli + ' >>>')
      console.log(msg)
      console.log(deli + ' <<<')
  },
  //随机字符串
  randomString:function(len) {
  　　len = len || 32;
  　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  　　var maxPos = $chars.length;
  　　var pwd = '';
  　　for (var i = 0; i < len; i++) {
  　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  　　}
  　　return pwd;
  },

  //下载
  download(url, d = {}) {
      const toType = (obj) => {
          return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
      }

      const filterNull = (o) => {
          if (toType(o) !== 'object' || o.nofilter) return o;
          for (var key in o) {

              if (toType(o[key]) === 'string') {
              o[key] = o[key].trim();

              };
          };
          return o;
      }


    return new Promise((resolve, reject) => {
        try {
              var iframe, idoc, ihtml, data = filterNull(d);
              iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.name = 'jh_dd_if';
              iframe.id = 'jh_dd_if';
              var form = document.createElement('form');
              var load = function () {
              var doc = iframe.contentWindow || iframe.contentDocument;
              if (doc.document) doc = doc.document;
              var req = doc.body.textContent;
              if (req) {
                  var reqData = eval("(" + req + ")") || {}
                  if (reqData.code == '00000003' || reqData.code == '00000002') {
                  window.location.href = '/JcLogin';
                  return;
                  };
                  if (reqData.code == '00000000') {
                  alert('下载成功')
                  } else {
                  alert(reqData.msg || '下载失败', 'error')
                  }
              }
              setTimeout(function () {
                  document.body.removeChild(iframe);
                  document.body.removeChild(form);
              }, 5000 * 60 * 5)
              }
              iframe.attachEvent ? iframe.attachEvent('onload', load) : iframe.onload = load;
              document.body.appendChild(iframe);
              form.style.display = 'none';
              //form.action = download + url;
              form.action = url;
              form.method = 'GET';
              form.target = 'jh_dd_if';
              Object.keys(data).forEach(function (key) {
              ihtml += "<input type='hidden' name='" + key + "' value='" + (data[key] || '') + "'>";
              });
              form.innerHTML += ihtml;
              document.body.appendChild(form);
              setTimeout(function () {
                  form.submit();
              })
          
              setTimeout(() => {
              resolve()
              }, 3500);
          } catch (error) {
              reject(error)
              console.error(error)
          }
    })

},
  //打印
  print : function (id) {
      let subOutputRankPrint = document.getElementById(id);
      let newContent =subOutputRankPrint.innerHTML;
      let oldContent = document.body.innerHTML;
      document.body.innerHTML = newContent;
      window.print();
      window.location.reload();
      document.body.innerHTML = oldContent;
      return false;
  },
  //获取数组最后一个值
  getArrLastVal : function (arr) {
      return arr[(arr.length-1)];
  },
  //对象转参数
  objToString : function (obj) {
      var arr = [];
      for (var i in obj) {
          arr.push(i+'='+obj[i]);
      }
      return arr.join('&');
  },
  //获取列表里面的某字段集合
  getFieldInList : function (list, key) {
      var arr = [];
      for (var i=0;i<list.length;i++) {
          arr.push(list[i][key]);
      }
      return arr;
  },
  //获取列表里面的某字段集合
  array_colum : function (list, key) {
      var arr = {};
      for (var i=0;i<list.length;i++) {
          arr[list[i][key]] = list[i];
      }
      return arr;
  },
  //合并数组
  array_merge : function (arr) {
      var tmp = [];
      for (var i in arr) {
          for (var j in arr[i]) {
              tmp[j] = arr[i][j]
          }
      }

      return tmp;
  },
  //获取索引位置
  get_arr_key_index(arr, key, value) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][key] == value) {
        return i;
      }
    }
    return -1;
  },
  //判断数组里是否有某值
  arrValExist : function (arr, val) {
      for (var i=0; i<arr.length; i++) {
          if (arr[i] == val) {
          return true;
          }
      }

      return false;
  },
  //检测数组内是否包含某值
  isExistKeyVal : function (arr, key, val) {
      for (var i = 0; i<arr.length; i++) {
          if (arr[i][key] == val) {
          return true;
          }
      }

      return false;
  }, 
  //删除数组的某个值
  removeArrVal(arr, val){
      var tmp = [];
      for (var i=0; i<arr.length; i++) {
        if (arr.i != val) {
          tmp.push(arr.id);
        }
      } 
      
      return tmp;
  },
  /**
       * 获取区间日期
       * @param dateNow :Date类
       * @param intervalDays ：间隔天数
       * @param bolPastTime  ：Boolean,判断在参数date之前，还是之后，
  */
  getDateRange(dateNow,intervalDays,bolPastTime){
      let oneDayTime = 24 * 60 * 60 * 1000;
      let list = [];
      let lastDay;

      if(bolPastTime == true){
          lastDay = new Date(dateNow.getTime() - intervalDays * oneDayTime);
          list.push(this.formateDate(lastDay));
          list.push(this.formateDate(dateNow));
      }else{
          lastDay = new Date(dateNow.getTime() + intervalDays * oneDayTime);
          list.push(this.formateDate(dateNow));
          list.push(this.formateDate(lastDay));
      }
      return list;
    },
    formateDate(time){
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()

      if (month < 10) {
        month = '0' + month
      }

      if (day < 10) {
        day = '0' + day
      }

      return year + '-' + month + '-' + day + ''
    },
    implode_field(arr, field, deli = ',', is_filter_empty = true){
      var tmp = [];
      for (var i=0; i<arr.length; i++) {
          if (is_filter_empty && !arr[i][field]) continue;
          tmp.push(arr[i][field]);
      }

      return tmp.join(deli);
    },
    get_current_time(){
      var myDate = new Date();
      var Y = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      var m = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      var d = myDate.getDate(); //获取当前日(1-31)
      var H = myDate.getHours(); //获取当前小时数(0-23)
      var i = myDate.getMinutes(); //获取当前分钟数(0-59)
      var s = myDate.getSeconds(); //获取当前秒数(0-59)

      return Y + '-' + m + '-' + d + ' ' + H + ':' + i + ':' + s;
    },
    //路由跳转
  redirect: function (url, isBlank = false) {
    if (isBlank) {
        if (url.indexOf('http://') == 0 || url.indexOf('https://') == 0) {
        window.open(url);
        } else {
            let routeData = this.$router.resolve({ path: url});
            window.open(routeData.href, '_blank');
        }
    } else {
        // this.$router.push({path:url});
        this.$router.push(url);
    }
  },
}



// WEBPACK FOOTER //
// ./src/util/js/tools.js